module.exports = __webpack_public_path__ + "static/img/redbag_03@2x.111b48d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/redbag_03@2x.png
// module id = 9W29
// module chunks = 0